import React from 'react';
import Backdrop from '@material-ui/core/Backdrop';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
    backdrop: {
        zIndex: theme.zIndex.drawer + 1,
        color: '#fff',
    },
    paper: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        flexDirection: 'column',
        flexWrap: 'wrap',
        maxWidth: '60vw',
        '& > *': {
            padding: theme.spacing(1.5),
            marginRight: theme.spacing(2),
            marginLeft: theme.spacing(2),
        },
    },
    heading: {
        fontSize: theme.typography.pxToRem(15),
        flexBasis: '33.33%',
        flexShrink: 0,
    },
    secondaryHeading: {
        fontSize: theme.typography.pxToRem(15),
        color: theme.palette.text.secondary,
    },
}));

export default function SimpleBackdrop(props) {
    const classes = useStyles();

    return (
        <div>
            <Backdrop className={classes.backdrop} open={props.open} onClick={props.close}>
                <Paper className={classes.paper} elevation={3}>
                    <Typography style={{ whiteSpace: 'pre-line' }} className={classes.heading} variant="subtitle1">
                        1. Select the event you want to play
                    </Typography>
                    <Typography style={{ whiteSpace: 'pre-line' }} className={classes.heading} variant="subtitle1">
                        2. On the map, search for the place where you want to play the game
                    </Typography>
                    <Typography style={{ whiteSpace: 'pre-line' }} className={classes.heading} variant="subtitle1">
                        3. If you don't see any markers on the map, click "Center Pins To Map"
                    </Typography>
                    <Typography style={{ whiteSpace: 'pre-line' }} className={classes.heading} variant="subtitle1">
                        4. Drag and drop the markers where you want them
                    </Typography>
                    <Typography style={{ whiteSpace: 'pre-line' }} className={classes.heading} variant="subtitle1">
                        5. Click Save
                    </Typography>
                    <Typography style={{ whiteSpace: 'pre-line' }} className={classes.heading} variant="subtitle1">
                        6. Open the SeekCity app, search for your game and play
                    </Typography>
                </Paper>
            </Backdrop>
        </div>
    );
}